import {
  ICheckActiveService,
  ICheckActiveServiceResponse,
} from "../interfaces/services/ICheckActiveService";
import enviroment from "corss-cutting/enviroment";

const SERVICE_STATUS_URL =
  "https://rakgglrfdodxfejmuaus.supabase.co/functions/v1/service-status";

const SUPABASE_ANON_KEY =
  enviroment.supabaseAnonKey ||
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJha2dnbHJmZG9keGZlam11YXVzIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjgyNTMyMjcsImV4cCI6MjA4MzgyOTIyN30.64Zq9swMOKvLkJWaRcHQmfDkRImVLWIvNNYeu14e9YA";

export const CheckActiveService = (): ICheckActiveService => {
  const checkActiveService = async (
    localId: string,
    historicoAssociacaoId: string
  ): Promise<ICheckActiveServiceResponse> => {
    const params = new URLSearchParams({
      local_id: localId,
      historico_associacao_id: historicoAssociacaoId,
    });
    const response = await fetch(
      `${SERVICE_STATUS_URL}?${params.toString()}`,
      {
        method: "GET",
        headers: {
          apikey: SUPABASE_ANON_KEY,
          Authorization: `Bearer ${SUPABASE_ANON_KEY}`,
          "Content-Type": "application/json",
          "x-client-info": "external-curl",
        },
      }
    );
    if (!response.ok) {
      throw new Error(
        `service-status failed: ${response.status} ${response.statusText}`
      );
    }
    return response.json() as Promise<ICheckActiveServiceResponse>;
  };

  return { checkActiveService };
};
